import Image from 'next/image';
import styled from 'styled-components';
import StyledLink from '../../../../shared/components/global/StyledLink';
import { Button, ButtonSizes } from '../../../../shared/styles/button';
import { device } from '../../../../shared/styles/device';
import { GridContainer, GridItem } from '../../../../shared/styles/grid/grid';

const GridItemContent = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
    padding-left: 0;

    @media ${device.tablet} {
        padding-left: 40px;
        grid-template-columns: 1fr 1fr;
    }
    @media ${device.laptop} {
        grid-template-columns: 1fr 1fr;
    }

    a {
        width: fit-content;
        margin-right: auto;
    }
`;

const TalentpoolBlockText = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    padding: 30px;
    align-items: flex-start;
    justify-self: flex-start;

    h2, a {
        width: auto;
    }
    
    @media ${device.tablet} {
        text-align: left;
        align-items: flex-start;
        padding-top: 48px;
        padding-bottom: 48px;
        padding-left: 0;
        padding-right: 0;
        justify-self: flex-start;
    }
`;

const TalentpoolBlockHeadline = styled.h2`
    font-size: 24px;
    line-height: 34px;
    font-weight: 700;

    margin-top: 0;
    margin-bottom: 12px;
    
    @media ${device.tablet} {
        font-size: 38px;
        line-height: 54px;
        margin-bottom: 16px;
    }
`;
const EventBannerImageContainer = styled.div`
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    min-height: 200px;
    @media ${device.tablet} {
        min-height: unset;
    }
`;


const PostEventBanner = () => {
    return (
        <GridContainer>
            <GridItem color={"#FDC228"}>
                <GridItemContent>
                    <TalentpoolBlockText>
                        <TalentpoolBlockHeadline>Kennst du das <br /> STELL-MICH-EIN Event?</TalentpoolBlockHeadline>
                        <StyledLink href={"/speed-recruiting"}>
                            <Button primary size={ButtonSizes.s}>{"Mehr erfahren >"}</Button>
                        </StyledLink>
                    </TalentpoolBlockText>
                    <EventBannerImageContainer>
                        <Image
                            src="/images/aboutus/sme.jpg"
                            alt="STELL-MICH-EIN Event Banner"
                            layout="fill"
                            objectFit="cover"
                        />
                    </EventBannerImageContainer>
                </GridItemContent>
            </GridItem>
        </GridContainer>
    )
}

export default PostEventBanner